import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import type { OutgoingInvoice } from "@/models/outgoing-invoice.model"

/** Invoices known to this client: those underway (the "Verzenden" panel) and any opened since. */
export const useOutgoingInvoiceStore = defineStore("outgoingInvoiceStore", () => {
  const outgoingInvoices: Ref<OutgoingInvoice[]> = ref([])

  return { outgoingInvoices }
})
